import { clientWithoutInterceptors } from '../utils/http';
import { htmlLlmInsight, llmInsight } from '../types/insight';
import { UtmVariantType } from '../types/utmParams';

export async function getInsights(utmVariant?: UtmVariantType, utmPromptName?: string): Promise<llmInsight[] | htmlLlmInsight[]> {
  switch (utmVariant) {
    case UtmVariantType.Vanilla:
      return await getLlmInsights(utmPromptName);
    case UtmVariantType.Custom:
      return await getHtmlInsights(utmPromptName);
    default:
      return await getLlmInsights();
  }
}

async function getHtmlInsights(promptName?:string): Promise<htmlLlmInsight[]> {
  const response = await clientWithoutInterceptors.post('/api/html-llm-insights', { promptName });
  if (response.status !== 200) {
    throw new Error('Could not get insights');
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return response.data.length === 0 ? [] : response.data.sort((a: htmlLlmInsight, b: htmlLlmInsight) => a.index - b.index);
}

async function getLlmInsights(promptName?:string): Promise<llmInsight[]> {
  const response = await clientWithoutInterceptors.post('/api/llm-insights', { promptName });
  if (response.status !== 200) {
    throw new Error('Could not get insights');
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return response.data.length === 0 ? [] : response.data.sort((a: llmInsight, b: llmInsight) => a.index - b.index);
}
